import { render, staticRenderFns } from "./PortalLogin.vue?vue&type=template&id=fcb75972&scoped=true&"
import script from "./PortalLogin.vue?vue&type=script&lang=js&"
export * from "./PortalLogin.vue?vue&type=script&lang=js&"
import style0 from "./PortalLogin.vue?vue&type=style&index=0&id=fcb75972&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb75972",
  null
  
)

export default component.exports